import { Award, Crown, Gem } from "lucide-react";

export const RANK_META = {
  ORO: { Icon: Award, cls: "bg-sun text-ink", ring: "border-sun" },
  DIAMANTE: { Icon: Gem, cls: "bg-[#7FD1F7] text-ink", ring: "border-[#7FD1F7]" },
  CORONA: { Icon: Crown, cls: "bg-coral text-white", ring: "border-coral" },
};

const fmt = (n) => `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USD`;
const range = (r) => (r.max_units ? `${r.min_units} a ${r.max_units}` : `${r.min_units} o más`);

export const RankBadge = ({ rank, testId }) => {
  if (!rank) return <span className="rounded-full bg-ink/10 px-2.5 py-1 text-xs font-semibold text-ink/60" data-testid={testId}>Sin rango</span>;
  const { Icon, cls } = RANK_META[rank];
  return <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-bold tracking-wide ${cls}`} data-testid={testId}><Icon className="h-3.5 w-3.5" /> {rank}</span>;
};

/** Rango del mes + pools de estímulo (porcentaje de la venta mensual global de códigos, repartido entre quienes califican). */
export const RanksCard = ({ ranks, myRank, globalSales, bonus }) => (
  <div className="rounded-[1.5rem] border border-ink/10 bg-white p-5" data-testid="ranks-card">
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.14em] text-leaf-deep">Rangos y estímulos del mes</p>
        <div className="mt-2 flex items-center gap-3">
          <RankBadge rank={myRank?.rank} testId="my-rank" />
          <span className="text-sm text-ink/70" data-testid="my-rank-units">{myRank?.units || 0} ventas / pagos activos este mes</span>
        </div>
        <p className="mt-2 text-sm text-ink/70" data-testid="my-rank-next">
          {myRank?.next_rank ? <>Te faltan <strong className="text-ink">{myRank.missing}</strong> ventas o pagos activos para el rango <strong className="text-ink">{myRank.next_rank}</strong>.</> : "Has alcanzado el rango máximo de este mes."}
        </p>
      </div>
      <div className="rounded-2xl bg-ink px-5 py-4 text-white">
        <p className="text-xs text-[#AEB7D3]">Tu estímulo proyectado</p>
        <p className="font-display text-2xl font-semibold" data-testid="my-rank-bonus">{fmt(bonus)}</p>
        <p className="text-[11px] text-[#AEB7D3]">Venta global del mes: {fmt(globalSales)}</p>
      </div>
    </div>
    <ul className="mt-5 grid gap-3 sm:grid-cols-3" data-testid="ranks-list">
      {(ranks || []).map((r) => {
        const mine = myRank?.rank === r.rank;
        return (
          <li key={r.rank} className={`rounded-2xl border-2 p-4 ${mine ? RANK_META[r.rank].ring : "border-ink/10"}`} data-testid={`rank-${r.rank.toLowerCase()}`}>
            <div className="flex items-center justify-between"><RankBadge rank={r.rank} /><span className="font-display text-xl font-semibold">{Math.round(r.pct * 100)}%</span></div>
            <p className="mt-2 text-xs text-ink/70">Requiere {range(r)} ventas o pagos activos en el mes.</p>
            <p className="mt-2 text-sm"><span className="text-ink/60">Pool:</span> <strong>{fmt(r.pool)}</strong></p>
            <p className="text-sm"><span className="text-ink/60">Calificados:</span> <strong>{r.qualifiers}</strong>{r.qualifiers > 0 && <span className="text-ink/60"> · {fmt(r.share)} c/u</span>}</p>
          </li>
        );
      })}
    </ul>
    <p className="mt-4 text-xs text-ink/60">El pool de cada rango es un porcentaje de la venta mensual global de códigos de la empresa (no incluye membresías) y se reparte en partes iguales entre quienes califican. No es acumulativo: cobras únicamente el pool del rango que alcanzas. Cuentan pagos repetidos de tus mismos distribuidores o clientes.</p>
  </div>
);
